'use client';

import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger, TextButton } from '@repo/ui';
import { useRouter, useParams, usePathname } from 'next/navigation';

import { ArticleView } from '@/app/_components/terms/ArticleView';

export const TermContentSection = ({ term, versions }: { term: any; versions: any }) => {
  const router = useRouter();
  const pathname = usePathname();
  const urlParams = useParams();
  const termContent = term.isrichcontent ? term.richcontent : term.content;
  const isPopup = pathname.startsWith('/popup');

  return (
    <div className={'compact:pt-normal-large pt-spacious-small pb-huge-medium flex-1 max-w-full overflow-hidden'}>
      <h1 className="terms-title compact:mb-4 font-bold mb-6">{term?.type.name}</h1>
      <div className="flex items-center text-sm text-gray-600 w-full">
        시행일자 :&nbsp;
        <div className="ml-2 border border-gray-200 text-xs font-medium text-gray-800 hover:bg-gray-100 rounded-bzc-small">
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
              <TextButton variant={'secondary'} size={'small'}>
                {term?.version}&nbsp;&nbsp;
              </TextButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent className={'w-48 py-2'} align="end">
              <DropdownMenuGroup>
                {versions
                  .filter(({ key }: { key: string }) => {
                    const queryTerm = urlParams.terms?.[0];
                    const terms = key.split('-');
                    const termKey = terms.slice(0, terms.length - 3).join('-');
                    return queryTerm === termKey;
                  })
                  .map(({ version }: { version: string }) => (
                    <DropdownMenuItem
                      key={version}
                      onClick={() => {
                        const path = `${isPopup ? '/popup' : ''}/terms/${term?.type.key}/${version}`;
                        // 팝업(iframe)일 때 시행일자 변경 시 히스토리를 쌓지 않기 위해 replace 처리
                        if (isPopup) router.replace(path);
                        else router.push(path);
                      }}
                    >
                      {version}
                    </DropdownMenuItem>
                  ))}
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <ArticleView content={termContent} />
    </div>
  );
};
